export const detectNameCollisions = (names: Array<string>, inputName: string) => {
  return !!names.find((subName) => inputName.toLowerCase().trim() === subName.toLowerCase().trim());
};
